import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useState } from 'react';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void | Promise<unknown>;
};

export const DeleteJobModal = ({ onCancel, onSuccess }: TProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onSuccess();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalWrapper width="400px">
      <ModalTitle>Confirm</ModalTitle>
      <p className="m-0 text-center">
        This action will permanently remove this job from the AutoScript platform. All associated transcripts, audio
        files, and related data will be permanently deleted and cannot be recovered.
      </p>
      <p className="m-0 text-center">Are you sure you want to delete?</p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          void handleSubmit();
        }}
      >
        <div className="mx-auto flex justify-center w-[300px] gap-2.5">
          <OutlinedButton type="button" onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </OutlinedButton>
          <Button type="submit" disabled={isSubmitting}>
            Delete
          </Button>
        </div>
      </form>
    </ModalWrapper>
  );
};
